import React, { useState } from 'react';
import { PasswordChanged } from '../../../Services/Auth/Auth';
import Swal from "sweetalert2";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { Eye, EyeOff } from "lucide-react";

const Changedpassword = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });




  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);




  const handleChange = (e) => {
    const { name, value } = e.target;
    setPassword({
      ...password,
      [name]: value
    });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.newPassword !== password.confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: "New password and confirm password do not match",
        timer: 5000,
        showConfirmButton: false
      });
      return;
    }

    try {
      const response = await PasswordChanged({
        oldPassword: password.oldPassword,
        newPassword: password.newPassword,
        userid: user_id
      });

      if (response.status) {
        setPassword({
          oldPassword: "",
          newPassword: "",
          confirmPassword: ""
        });

        Swal.fire({
          icon: 'success',
          title: 'Updated',
          text: response.message,
          timer: 5000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: "Internal error",
        timer: 5000,
        showConfirmButton: false
      });
    }
  };




  const renderPasswordField = (label, name, value, showPassword, setShowPassword) => (
    <div className="col-sm-4 mb-3">
      <label className="form-label">{label}</label>
      <div className="input-group">
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          placeholder={label}
          name={name}
          value={value}
          onChange={handleChange}
          required
        />
        <span
          className="input-group-text"
          style={{ cursor: "pointer" }}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
      </div>
    </div>
  );




  return (
    <div className="container-fluid" style={{ minHeight: 723 }}>
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div className="card profile-card card-bx">
            <div className="card-header">
              <h6 className="card-title">Change Password</h6>
            </div>
            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="card-body">
                <div className="row">
                  {renderPasswordField(
                    "Current Password",
                    "oldPassword",
                    password.oldPassword,
                    showOldPassword,
                    setShowOldPassword
                  )}

                  {renderPasswordField(
                    "New Password",
                    "newPassword",
                    password.newPassword,
                    showNewPassword,
                    setShowNewPassword
                  )}

                  {renderPasswordField(
                    "Confirm New Password",
                    "confirmPassword",
                    password.confirmPassword,
                    showConfirmPassword,
                    setShowConfirmPassword
                  )}
                </div>
              </div>
              <div className="card-footer align-items-center d-flex">
                <button type="submit" className="btn btn-primary ">
                  UPDATE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changedpassword;
